import { LoadingOutlined } from '@ant-design/icons';
import React from 'react';
import './_button.scss';

interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  children?: any;
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
  icon?: any;
  active?: boolean;
  style?: any;
  htmlType?: 'button' | 'submit' | 'reset';
  type?: 'button' | 'submit' | 'reset';
  size?: 'default' | 'compact';
  tone?: 'default' | 'danger';
  ariaLabel?: string;
}

const PrimaryButton: React.FC<Props> = ({ onClick, className, children, loading, disabled, block, icon, htmlType, type, size = 'default', tone = 'default', ariaLabel, style }) => {
  const buttonType = type || htmlType || 'button';
  return (
    <button
      type={buttonType}
      className={`button-primary button--${size} button--${tone} ${block ? 'block' : ''} ${className || ''} ${loading || disabled ? 'disabled' : ''} `}
      disabled={disabled || loading}
      onClick={onClick}
      aria-label={ariaLabel}
      style={style}
    >
      <span>{children}&nbsp;</span>
      <span style={{ float: 'right' }}>{icon}</span>
      {loading && <LoadingOutlined className="btn-loader" />}
    </button>
  );
};

export const SecondaryButton: React.FC<Props> = ({ icon, onClick, className, children, loading, disabled, block, htmlType, type, size = 'default', tone = 'default', ariaLabel }) => {
  const buttonType = type || htmlType || 'button';
  return (
    <button
      type={buttonType}
      className={`button-secondary button--${size} button--${tone} ${block ? 'block' : ''} ${className || ''} ${loading || disabled ? 'disabled' : ''}`}
      disabled={disabled || loading}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {icon && <span style={{ marginRight: '8px' }}>{icon}&nbsp;</span>}
      <span>{children}</span>
    </button>
  );
};

export const TertiaryButton: React.FC<Props> = ({ icon, onClick, className, children, loading, disabled, htmlType, type, size = 'default', tone = 'default', ariaLabel }) => {
  const buttonType = type || htmlType || 'button';
  return (
    <button
      type={buttonType}
      className={`button-tertiary button--${size} button--${tone} ${className || ''} ${loading || disabled ? 'disabled' : ''}`}
      disabled={loading || disabled}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {icon && <span className="button-tertiary__icon">{icon}</span>}
      {children}
    </button>
  );
};

interface IconButtonProps extends Pick<Props, 'onClick' | 'disabled' | 'loading' | 'className' | 'ariaLabel'> {
  icon: React.ReactNode;
  tone?: 'default' | 'danger';
}

export const IconButton: React.FC<IconButtonProps> = ({ ariaLabel, className, disabled, icon, loading, onClick, tone = 'default' }) => (
  <button
    type="button"
    aria-label={ariaLabel}
    className={`button-icon button-icon--${tone} ${className || ''} ${loading || disabled ? 'disabled' : ''}`}
    disabled={loading || disabled}
    onClick={onClick}
  >
    {icon}
    {loading && <LoadingOutlined className="btn-loader" />}
  </button>
);

export const TabButton: React.FC<Props> = (props) => {
  return (
    <button className={`primary-text tab-button ${props.active ? 'active' : null} `} onClick={props.onClick} style={props.style} >
      {props.children}
    </button>
  );
};

export default PrimaryButton;
